<template>
    <main-layout>
        <app-header icon="factory">
            Détenteurs
        </app-header>

        <action-bar :back="{ name: 'home' }">
            <router-link
                class="btn add btn-full"
                id="main-action"
                event=""
                to="new-detenteur"
                @click.native.prevent="checkCanEdit('new-detenteur')"
            >
                <i class="icon-add"></i>
                <strong>Ajouter</strong> un détenteur
            </router-link>
        </action-bar>

        <filter-bar @searchBarChanged="updateSearch" placeholderFilter="Recherche par Nom, Code client, Adresse..." type-history="detenteur"></filter-bar>

        <div class="infoAsync" v-if="asyncDetenteurs === true">
            <p><img class="spinner-load" src="../../img/spinner-load.gif"> Synchronisation en cours en arrière plan</p>
        </div>

        <div id="detenteurs-items" class="list">
            <detenteur-item v-for="detenteur in paginatedList" :key="detenteur.id" :detenteur="detenteur" :typeuser="typeUser"></detenteur-item>
        </div>

        <div class="pagination-buttons">
            <button @click="previousPage" v-show="paginator.showPreviousButton && !strSearch">Page précédente</button>
            <button @click="nextPage" v-show="paginator.showNextButton && !strSearch">Page suivante</button>
        </div>
    </main-layout>
</template>

<script>
import DetenteurItem from './DetenteurItem.vue'
import Detenteur from '../../js/models/Detenteur'
import History from '../../js/core/History'

export default {
    data() {
        return {
            dets: [ ],
            strSearch: '',
            detenteurs: [],
            canEditDetenteurs: true,
            typeUser: localStorage.getItem('typeUser'),
            paginator: {
                currentPage: 1,
                pageSize: 70,
                showPreviousButton: false,
                showNextButton: false,
            },
            // asyncDetenteurs en string.. car localStorage ne prend que des strings
            asyncDetenteurs: localStorage.getItem('asyncDetenteurs') === 'true',
        }
    },
    methods: {
        onAsyncDetenteursChange() {
            this.asyncDetenteurs = localStorage.getItem('asyncDetenteurs') === 'true'
        },
        updateSearch(str) {
            if (str[0].length >= 2) {
                this.strSearch = this.normalize(String(str[0]))
            } else if (str[0].length === 0) {
                this.strSearch = ''
            }
        },

        fetchDetenteurs() {
            Detenteur.getList().then((data) => {
                if (this._isDestroyed) return;
                this.detenteurs = _.sortBy((data || []).filter(Boolean), [
                    (det) => {
                        if (det.raison_sociale) {
                            return det.raison_sociale.toUpperCase();
                        } else {
                            return ''; // Retourne une chaîne vide si raison_sociale est undefined
                        }
                    },
                ]);
                this.updatePaginator();
            });
        },


        checkCanEdit(e) {
            if (JSON.parse(localStorage.getItem('canEditDetenteurs')) === true) {
                this.$router.push(e)
            } else {
                swal(
                    'Action non autorisée',
                    "Vous n'avez pas le droit d'ajouter de détenteurs, veuillez contacter votre administrateur",
                    'error'
                )
            }
        },

        normalize(s) {
            if (typeof s !== 'string') {
                return ''
            }
            let r = s.toLowerCase()

            r = r.replace(/\s/g, '')
            r = r.replace(/[àáâãäå]/g, 'a')
            r = r.replace(/æ/g, 'ae')
            r = r.replace(/ç/g, 'c')
            r = r.replace(/[èéêë]/g, 'e')
            r = r.replace(/[ìíîï]/g, 'i')
            r = r.replace(/ñ/g, 'n')
            r = r.replace(/[òóôõö]/g, 'o')
            r = r.replace(/œ/g, 'oe')
            r = r.replace(/[ùúûü]/g, 'u')
            r = r.replace(/[ýÿ]/g, 'y')
            r = r.replace(/\W/g, '')

            return r
        },

        updatePaginator() {
            const totalItems = this.filterList.length
            this.paginator.showPreviousButton = this.paginator.currentPage > 1
            this.paginator.showNextButton =
                totalItems > this.paginator.currentPage * this.paginator.pageSize
        },

        nextPage() {
            if (this.paginator.currentPage < this.totalPages) {
                this.paginator.currentPage++
                this.updatePaginator()
            }
        },

        previousPage() {
            if (this.paginator.currentPage > 1) {
                this.paginator.currentPage--
                this.updatePaginator()
            }
        },
    },
    computed: {
        filterList() {
            const normalizedSearch = this.normalize(this.strSearch);
            return this.detenteurs.filter((det) => {
                const normalizedRaisonSociale = this.normalize(det.raison_sociale);
                const normalizedVille = this.normalize(det.ville);
                const normalizedCodeClient = det.hasOwnProperty('code_client') && det.code_client !== null ? this.normalize(det.code_client) : '';
                const normalizedAdresse = this.normalize(det.adresse);
                const normalizedCodePostal = this.normalize(det.code_postal);
                const normalizedCustom = det.hasOwnProperty('custom') && det.custom !== null ? this.normalize(det.custom) : '';

                return (
                    normalizedRaisonSociale.includes(normalizedSearch) ||
                    normalizedVille.includes(normalizedSearch) ||
                    normalizedCodeClient.includes(normalizedSearch) ||
                    normalizedAdresse.includes(normalizedSearch) ||
                    normalizedCodePostal.includes(normalizedSearch) ||
                    normalizedCustom.includes(normalizedSearch)
                );
            });
        },

        paginatedList() {
            const start = (this.paginator.currentPage - 1) * this.paginator.pageSize
            const end = start + this.paginator.pageSize
            return this.filterList.slice(start, end)
        },

        totalPages() {
            return Math.ceil(this.filterList.length / this.paginator.pageSize)
        },
    },
    mounted() {
        window.addEventListener('localStorageAsyncDetenteurs', this.onAsyncDetenteursChange)
        this.fetchDetenteurs()
        History.clearHistory('installation');
    },
    beforeDestroy() {
        window.removeEventListener('localStorageAsyncDetenteurs', this.onAsyncDetenteursChange)
    },
    components: {
        DetenteurItem,
    },
}
</script>
<style>
.infoAsync {
    background-color: #eee;
    padding: 10px 0;
    margin-bottom: 10px;
    text-align: center;
    display: flex;
    justify-content: center; /* Centrer horizontalement */
    align-items: center; /* Aligner verticalement */
}

.infoAsync p {
    display: flex;
    align-items: center; /* Aligner verticalement le contenu du paragraphe */
    margin: 0; /* Supprimer les marges par défaut du paragraphe */
}

.spinner-load {
    width: 50px;
    height: 50px;
    margin-right: 10px; /* Ajouter de l'espace entre l'image et le texte */
}

.list-item {
    list-style: none !important;  /* au cas où il hérite d’un style de liste */
}
</style>



// WEBPACK FOOTER //
// ListeDetenteurs.vue?7a3d41b0